//tslint:disable:max-file-line-count
import * as PropTypes from 'prop-types';
import * as React from 'react';

import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { ButtonCollapsed } from '@cian/components';
import { ErrorLogComponent } from '@cian/error-log-component';
import { IExperiment } from '../../../api/experiments';
import { FeedbackComplaintPopupContainer } from '../../../FeedbackExperiment/components/PopupWithComplaint/ComplaintPopup/container';
import { FeedbackPopupContainer as FeedBackPopupC } from '../../../FeedbackExperiment/components/PopupWithComplaint/FeedbackPopup';
import { FeedbackFormPopupContainer } from '../../../FeedbackExperiment/components/PopupWithForm/FeedbackFormPopup';
import { FeedbackPopupContainer as FeedbackPopupB } from '../../../FeedbackExperiment/components/PopupWithForm/FeedbackPopup';
import { PopupFeedbackSentContainer } from '../../../FeedbackExperiment/components/PopupWithForm/PopupFeedbackSent';
import { EGroup, getGroup } from '../../../FeedbackExperiment/utils';
import { BannerContainer as StalkerBanner } from '../../../registrationTriggers/StalkerBanner/components/Banner';
import { IContext } from '../../../store';
import { EHideOfferState } from '../../../store/hide_offer';
import { isABDemandTrapExperiment } from '../../../utils/ab_demand_trap_new_design';
import { getRandomId } from '../../../utils/banners';
import { TgbBannerContainer } from '../../adfox/templates/tgb/banner';
import { AdditionalFeaturesCommercialContainer } from '../../additional_features/container';
import { AdminButtonsContainer } from '../../admin_buttons/container';
import { OfferCardAsideContainer } from '../../aside/container';
import { AsideBannersContainer } from '../../aside_banners/container';
import { AuthorContainer } from '../../author/container';
import { AuthorBrandContainer } from '../../author_brand/container';
import { AuthorAsideContainer } from '../../author_aside/container';
import { AuthorAsideBrandContainer } from '../../author_aside_brand/container';
import { BottomControlPanelContainer } from '../../bottom_control_panel/container';
import { BtiCommercialContainer } from '../../bti_commercial_container';
import { BtiDistrictContainer } from '../../bti_commercial_district/container';
import { BtiDistrictRatingContainer } from '../../bti_district_rating/container';
import { BtiCommercialHouseDataContainer } from '../../bti_commercial_house_data/container';
import { CommercialAboutBuildingContainer } from '../../commercial/about_building/container';
import { CommercialAboutOtherContainer } from '../../commercial/about_other/container';
import { ContactsMainContainer } from '../../contacts_main/container';
import { ContractRentSaleContainer } from '../../contract_rent_sale/container';
import { DescriptionContainer } from '../../Description/Description.container';
import { HeaderAdminPanelContainer } from '../../header_admin_panel/container';
import { InfrastructureContainer } from '../../infrastructure/container';
import { MainContainer } from '../../main/container';
import { OfferMapContainer } from '../../map/container';
import { OfferCardNavigationContainer } from '../../navigation/container';
import { OfferAddedContainer } from '../../offer_added/container';
import { OfferBreadcrumbsContainer } from '../../offer_breadcrumbs/container';
import { OfferGallery } from '../../offer_gallery';
import { OfferIsHiddenBlock } from '../../offer_hidden_block';
import { OfferRefusedContainer } from '../../offer_refused/container';
import { OfferStatsContainer } from '../../offer_stats/container';
import { OfferUnpublishedContainer } from '../../offer_unpublished/container';
import { OfferValueAddedServicesContainer } from '../../offer_value_added_services/container';
import { PopupCallbackContainer } from '../../popups/callback/container';
import { HideOfferTopPopup } from '../../popups/hide_offer_top_popup';
import { LegendModalContainer } from '../../popups/legend/container';
import { PrintModalContainer } from '../../popups/print/container';
import { RemoveModalContainer } from '../../popups/remove/container';
import { PrintInformationContainer } from '../../print_information/container';
import { PrintPhotoContainer } from '../../print_photo/container';
import { SeoLinksContainer } from '../../seo_links/container';
import { SimilarOffersGroupsContainer } from '../../similar_offers/groups_container';
import { SimilarOffersLinkContainer } from '../../similar_offers_link/container';
import { TechnicalCharacterContainer } from '../../technical_character/container';
import { OfferTermsContainer } from '../../terms/container';
import { WarningsContainer } from '../../warnings/container';
import { BargainTermsBlockContainer } from '../bargain_terms/bargain_terms_group_container';
import { TrapContainer, ObservableTrapContainer } from '../../demand/containers';
import { TrapNewContainer } from '../../demand/containers/TrapNewContaner';
import { ModerationVerificationContainer } from '../../moderation_verification/container';
import { NewObjectStatsContainer } from '../../newobject_stats/container';
import { isAbExperiment } from '../../../utils/isAbExperiment';
import { CARD_VISIBILITY_OBSERVATION } from '../../../utils/cardVisibilityObservationExperiment';

import * as styles from '../index.css';
import { VerifyPhoneContainer } from '../../verifyPhone';

const PR1_RANDOM_TGB1 = getRandomId();
const PR1_RANDOM_TGB2 = getRandomId();
const PR1_RANDOM_TGB3 = getRandomId();

export interface IOtherCommercialCardProps {
  context: IContext;
}

export interface IOtherCommercialCardStoreProps {
  offer: IOfferSchema;
  experiments?: IExperiment[];
  isUserAuthenticated: boolean | null;
  isStalkerBannerShown: boolean;
  isBrandingAvailable: boolean;
  hideOfferStatus: EHideOfferState;
  hideOfferErrorMessage?: string;
  isTopPopupOpened: boolean;
  isHiddenByUser?: boolean | null;
}

export type IProps = IOtherCommercialCardProps & IOtherCommercialCardStoreProps;

export interface IOtherCommercialCardState {
  collapsed: boolean;
}

export class OtherCommercialCard extends React.Component<IProps, IOtherCommercialCardState> {
  private isMount: boolean;

  public constructor(props: IProps) {
    super(props);

    this.isMount = false;

    this.state = {
      collapsed: props.offer.status !== 'published',
    };
  }

  public context: IContext;

  public static childContextTypes = {
    config: PropTypes.object,
    httpApi: PropTypes.object,
    logger: PropTypes.object,
    makeRequest: PropTypes.func,
    telemetry: PropTypes.object,
  };

  public getChildContext() {
    return {
      config: this.props.context.config,
      httpApi: this.props.context.httpApi,
      logger: this.props.context.logger,
      makeRequest: this.props.context.makeRequest,
      telemetry: this.props.context.telemetry,
    };
  }

  public componentDidMount(): void {
    this.isMount = true;
  }

  public render() {
    const {
      experiments,
      isUserAuthenticated,
      isStalkerBannerShown,
      isBrandingAvailable,
      context,
      isHiddenByUser,
      hideOfferErrorMessage,
      isTopPopupOpened,
      hideOfferStatus,
    } = this.props;
    const feedbackGroup = experiments ? getGroup(experiments) : EGroup.aGroup;
    const hiddenObjectsLkUrl = context.config.get<string>('hiddenObjects.lkUrl') || '';
    const TrapContainerComponent =
      experiments && isAbExperiment(experiments, CARD_VISIBILITY_OBSERVATION) ? ObservableTrapContainer : TrapContainer;
    const isNewTrap = isABDemandTrapExperiment(experiments || []);

    return (
      <main className={styles['offer_card_page']}>
        {feedbackGroup === EGroup.bGroup && <FeedbackPopupB />}
        {feedbackGroup === EGroup.bGroup && <FeedbackFormPopupContainer />}
        {feedbackGroup === EGroup.cGroup && <FeedBackPopupC />}
        {feedbackGroup === EGroup.cGroup && <FeedbackComplaintPopupContainer />}
        <PopupFeedbackSentContainer />

        <div className={styles['offer_card_page-top']}>
          <OfferBreadcrumbsContainer />
          <div className={styles['offer_card_page-top_main']}>
            <div className={styles['offer_card_page-top_left']}>
              <OfferAddedContainer />
              <OfferStatsContainer />
            </div>
            <div className={styles['offer_card_page-top_right']}>
              <OfferValueAddedServicesContainer />
            </div>
          </div>
          <ModerationVerificationContainer />
          <HeaderAdminPanelContainer />
          <OfferRefusedContainer />
          <OfferUnpublishedContainer />
          <AdminButtonsContainer />
          <ErrorLogComponent logger={this.props.context.logger}>
            <WarningsContainer />
          </ErrorLogComponent>
        </div>
        <>
          {this.isMount && isTopPopupOpened && (
            <HideOfferTopPopup
              status={hideOfferStatus}
              hidden={Boolean(isHiddenByUser)}
              lkUrl={hiddenObjectsLkUrl}
              hideOfferErrorMessage={hideOfferErrorMessage}
            />
          )}
          {isHiddenByUser && <OfferIsHiddenBlock lkUrl={hiddenObjectsLkUrl} />}
        </>
        <div className={styles['offer_card_page-center']}>
          <div className={styles['offer_card_page-main']}>
            <ErrorLogComponent logger={this.props.context.logger}>
              <MainContainer />
            </ErrorLogComponent>
            {this.props.offer.status === 'published' && (
              <div>
                <OfferGallery reactErrorLogger={this.props.context.logger} />
                <PrintPhotoContainer />
              </div>
            )}
            <DescriptionContainer />
            {this.props.offer.status !== 'published' && (
              <ButtonCollapsed
                opened={!this.state.collapsed}
                buttonText="Показать информацию"
                closeButtonText="Скрыть информацию"
                onClick={() => this.setState({ collapsed: !this.state.collapsed })}
                buttonStyle={styles['button_collapsed']}
              />
            )}
            {this.props.offer.status === 'published' && <ContactsMainContainer />}
            <BargainTermsBlockContainer />
            <AdditionalFeaturesCommercialContainer />
            <InfrastructureContainer />
          </div>
          {(this.props.offer.status === 'published' || !this.state.collapsed) && (
            <div>
              <ErrorLogComponent logger={this.props.context.logger}>
                <OfferMapContainer />
              </ErrorLogComponent>
              <div className={styles['offer_card_page-technical']}>
                <CommercialAboutOtherContainer />
                <CommercialAboutBuildingContainer />
                <TechnicalCharacterContainer />
              </div>
              <div className={styles['offer_card_page-main']} style={{ marginTop: '8px' }}>
                <SimilarOffersLinkContainer />
              </div>
              <NewObjectStatsContainer />
              <div className={styles['offer_card_page-bti']}>
                <BtiCommercialContainer>
                  <BtiCommercialHouseDataContainer />
                  <BtiDistrictContainer />
                  <BtiDistrictRatingContainer />
                </BtiCommercialContainer>
              </div>
              <BottomControlPanelContainer />
              <ErrorLogComponent logger={this.props.context.logger}>
                <ContractRentSaleContainer />
              </ErrorLogComponent>
              <ErrorLogComponent logger={this.props.context.logger}>
                {isBrandingAvailable ? <AuthorBrandContainer /> : <AuthorContainer />}
              </ErrorLogComponent>
            </div>
          )}
        </div>
        <div className={styles['offer_card_page-aside']}>
          <OfferCardAsideContainer>
            <div className={styles['aside_content']}>
              <OfferTermsContainer />
              {isBrandingAvailable ? <AuthorAsideBrandContainer /> : <AuthorAsideContainer />}
            </div>
            <ErrorLogComponent logger={this.props.context.logger}>
              <AsideBannersContainer />
            </ErrorLogComponent>
          </OfferCardAsideContainer>
        </div>
        <div className={styles['offer_card_page-footer']}>
          <SimilarOffersGroupsContainer />
          <SeoLinksContainer />
          {isNewTrap ? <TrapNewContainer /> : <TrapContainerComponent />}
          <ErrorLogComponent logger={this.props.context.logger}>
            <VerifyPhoneContainer />
          </ErrorLogComponent>
          <div className={styles['bottom_banners']}>
            <ErrorLogComponent logger={this.props.context.logger}>
              <TgbBannerContainer
                className={styles['bottom_banner']}
                key="tgb1"
                randomId={PR1_RANDOM_TGB1}
                positionInfo="offer_card_tgb-1"
              />
            </ErrorLogComponent>
            <ErrorLogComponent logger={this.props.context.logger}>
              <TgbBannerContainer
                className={styles['bottom_banner']}
                key="tgb2"
                randomId={PR1_RANDOM_TGB2}
                positionInfo="offer_card_tgb-2"
              />
            </ErrorLogComponent>
            <ErrorLogComponent logger={this.props.context.logger}>
              <TgbBannerContainer
                className={styles['bottom_banner']}
                key="tgb3"
                randomId={PR1_RANDOM_TGB3}
                positionInfo="offer_card_tgb-3"
              />
            </ErrorLogComponent>
          </div>
        </div>

        <PopupCallbackContainer
          useOldWidget={true}
          makeRequest={this.props.context.makeRequest}
          host={(this.props.context.config.get('apiBaseUrl') as string) || ''}
        />

        <PrintModalContainer />
        <PrintInformationContainer />

        {!isUserAuthenticated && isStalkerBannerShown && (
          <ErrorLogComponent logger={this.props.context.logger}>
            <StalkerBanner />
          </ErrorLogComponent>
        )}

        <OfferCardNavigationContainer />
        <LegendModalContainer />
        <RemoveModalContainer />
      </main>
    );
  }
}
